import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Home::MwHomeLoginPage />",{ moduleName: "mewe/templates/web3-register.hbs" })